import { MsalAuthProvider, LoginType } from 'react-aad-msal';
 
// Msal Configurations
const config = {
  auth: {
    authority: 'https://login.microsoftonline.com/7584d747-9421-477d-8345-bedc5d73bc46',
    clientId: '9b969c38-4330-47b6-a8af-3bd0695fe4aa',
    postLogoutRedirectUri: window.location.origin,
    redirectUri: window.location.origin,
    validateAuthority: true,
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true
  }
};
 
export const authenticationParameters = {
    scopes: [
        `9b969c38-4330-47b6-a8af-3bd0695fe4aa/.default`
    ]
}
export const authenticationParametersGraph = {
    scopes: [
        'openid'
    ]
}
// Options
const options = {
  loginType: LoginType.Redirect,
  tokenRefreshUri: window.location.origin
}
 
export const authProvider = new MsalAuthProvider(config, authenticationParameters, options)